import bigInt from 'big-integer';
import React from 'react';
import { SidebarCover, SidebarTimeline } from './_components';

export function SidebarBundleDetails({ bundle }) {
  const bundleItems = bundle
    ? bundle.sort((a, b) => {
        return bigInt(a.fromDate).greaterOrEquals(b.fromDate) ? 1 : -1;
      })
    : [];
  return (
    <div className="chronos-sidebar-content chronos-sidebar-bundle-details-wrapper">
      <SidebarCover url={undefined} name={''} />
      <div className="chronos-sidebar-body">
        <div className="chronos-sidebar-type">
          <span>Collection</span>
        </div>
        <h4 className="chronos-sidebar-title">{bundle.length} Events</h4>
        <hr className="chronos-sidebar-separator" />
        {/* Collection List */}
        <SidebarTimeline events={bundleItems} hideTitle />
      </div>
    </div>
  );
}
